import { render } from "./englishImproveViewCourse.vue?vue&type=template&id=237fbbb8&scoped=true"
import script from "./englishImproveViewCourse.vue?vue&type=script&lang=js"
export * from "./englishImproveViewCourse.vue?vue&type=script&lang=js"

import "./englishImproveViewCourse.vue?vue&type=style&index=0&id=237fbbb8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237fbbb8"]])

export default __exports__